'use client'

import styled from '@emotion/styled'
import {
  toast as cToas,
  ToastContainer as cToastContainer,
  ToastPosition,
} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

interface ToastProps {
  message: string
  type: 'info' | 'success' | 'warning' | 'error' | 'progress'
  key?: string
}

const options = {
  position: 'top-right' as ToastPosition,
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: 'dark',
  style: {
    fontFamily: 'var(--font-family-sans)',
    fontSize: '14px',
    fontWeight: '600',
    background: '#171717',
    border: '1px solid rgba(81, 81, 81, 0.25)',
    borderRadius: '12px',
    color: 'rgba(255, 255, 255, 0.8)',
    boxShadow:
      '0 1px 4px 0 rgba(48, 48, 48, 0.14), 0 1px 2px 0 rgba(222, 222, 222, 0.08)',
  },
}

const toast = ({ message, type, key }: ToastProps) => {
  switch (type) {
    case 'info':
      return cToas.info(message, { toastId: key, ...options })
    case 'progress':
      return cToas.info(message, { toastId: key, ...options })
    case 'success':
      return cToas.success(message, { toastId: key, ...options })
    case 'warning':
      return cToas.warning(message, { toastId: key, ...options })
    case 'error':
      return cToas.error(message, { toastId: key, ...options })
  }
}

export default toast

const ToastContainer = styled(cToastContainer)`
  .Toastify__toast {
    font-family: var(--font-family-sans);
  }

  .Toastify__close-button {
    color: rgba(255, 255, 255, 0.6);
  }
`
export { ToastContainer }

export function dismiss(key: string) {
  cToas.dismiss(key)
}
